/* global angular */

angular.module('gc.readstatus',['gc.services'])
.service('ReadStatusService', ['$rootScope', 'LocalStorageService', function($rootScope, LocalStorageService) {
  "use strict";

  var threadId = null;
  var userId = null;
  var localStorageCache = null;

  this.setThreadId = function(id) {
    threadId = id;
  };

  // Called on page load and when user logs in
  $rootScope.$on('logged_in', function(event, user) {
    userId = user._id;
    localStorageCache = null;
    $rootScope.$broadcast('read:refresh', 'logged_in');
  });

  $rootScope.$on('logged_out', function() {

    // Check if the user just disconnected (cause the event is also called on page load for anonymous users)
    var justDisconnected = userId !== null;

    userId = null;

    if (justDisconnected) {
      // Mark all as unread, as user wouldn't understand why the statuses stay
      localStorageCache = [];
      writeToDisk();
    }

    $rootScope.$broadcast('read:refresh', 'logged_out');
  });

  // Check if a comment is already read
  this.isRead = function(commentId) {
    if (localStorageCache === null) {
      localStorageCache = readFromDisk() || [];
    }

    // migrate old values
    if (typeof localStorageCache === 'string') {
      localStorageCache = JSON.parse(localStorageCache);
    }

    return localStorageCache.indexOf(commentId) !== -1;
  };

  // Mark a comment as read
  this.markAsRead = function(cmt) {
    if (!this.isRead(cmt._id)) {
      localStorageCache.push(cmt._id);
      writeToDisk();
    }
  };

  function readFromDisk() {
    return LocalStorageService.getItem(getKey());
  }

  function writeToDisk() {
    LocalStorageService.setItem(getKey(), localStorageCache);
  }

  function getKey() {
    return 'read_' + threadId;
  }
}]);
